import { api } from './apiProvider';
import { convertUTCDateToLocalDate } from '../utils/formatUtils';

export interface RouteStopListRequest {
  fromDate: Date;
  toDate: Date;
}

export interface RouteStopListItem {
  id: string;
  address: string;
  isSkipped: boolean;
  isStop: boolean;
  serviceDate: Date;
  photoUrl?: string | null;
  serviceTechFirstName?: string | null;
  serviceTechLastName?: string | null;
  skippedReason?: string | null;
}

export interface ServiceTechInfo {
  firstName: string;
  lastName: string;
}

export interface ChecklistItem {
  description?: string | null;
  pictureId?: string | null;
}

export interface ServiceStopEntry {
  description?: string | null;
  sequence: number;
  unitOfMeasure?: string | null;
  value: number;
  poolId?: string | null;
}

export interface ServiceStop {
  poolId?: string | null;
  poolName?: string | null;
  calculatorEntries?: ServiceStopEntry[] | null;
  checklistItems?: ChecklistItem[] | null;
  readings?: ServiceStopEntry[] | null;
  dosages?: ServiceStopEntry[] | null;
}

export interface PictureInfo {
  id: string;
  photoUrl: string;
  caption: string;
  sequence: number;
}

export interface RouteStop {
  id: string;
  address: string;
  serviceDate: Date;
  completeTime: Date;
  pictures: PictureInfo[];
  serviceTech: ServiceTechInfo;
  serviceStops: ServiceStop[];
}

export interface PoolInfo {
  id: string;
  name: string | null;
  calculatorEntries?: ServiceStopEntry[] | null;
  readings?: ServiceStopEntry[] | null;
  dosages?: ServiceStopEntry[] | null;
}

export interface WorkOrder {
  id: string;
  address: string;
  serviceDate: Date;
  completeTime: Date;
  pools: PoolInfo[];
  pictures: PictureInfo[];
  serviceTech: ServiceTechInfo;
  checklistItems?: ChecklistItem[] | null;
}

const routeRoot = 'service-history';

export async function listRouteStops(request: RouteStopListRequest): Promise<RouteStopListItem[]> {
  const fromDate = convertUTCDateToLocalDate(request.fromDate, true);
  const toDate = convertUTCDateToLocalDate(request.toDate, true);
  const requestUrl = `${routeRoot}?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`;
  return await api.get(requestUrl, { credentials: 'include' }).json<RouteStopListItem[]>();
}

export async function getRouteStop(routeStopId: string): Promise<RouteStop> {
  return await api.get(`${routeRoot}/stops/${routeStopId}`, { credentials: 'include' }).json<RouteStop>();
}

export async function getWorkOrder(workOrderId: string): Promise<WorkOrder> {
  return await api.get(`${routeRoot}/work-orders/${workOrderId}`, { credentials: 'include' }).json<WorkOrder>();
}
